const LEFT_PAGES = 2;
const VISIBLE_SHOULDER_PAGES = 5;

export const getArrayOfPages = (currentPage: number, maxPage: number): number[] => {
  let prev: number[] = [];
  if (currentPage > LEFT_PAGES) {
    const arrLength =
      currentPage > VISIBLE_SHOULDER_PAGES + LEFT_PAGES ? VISIBLE_SHOULDER_PAGES : currentPage - LEFT_PAGES;
    prev = [...Array(arrLength)].map((item, index) => currentPage - index - 1).reverse();
  }

  let current: number[] = [];
  if (currentPage >= LEFT_PAGES && currentPage <= maxPage) {
    current = [currentPage];
  }

  let next: number[] = [];
  if (currentPage < maxPage) {
    const arrLength = maxPage - currentPage > VISIBLE_SHOULDER_PAGES ? VISIBLE_SHOULDER_PAGES : maxPage - currentPage;
    next = [...Array(arrLength)].map((item, index) => currentPage + index + 1);
  }

  const first = [1];

  return first.concat(prev, current, next);
};
